
import {Links} from '../routes/PathLink'

import {
  useUserDashboardStatsQuery,
} from 'data/dashboard-data';

export const SideMenu = () => {
  

   let user_type = localStorage.getItem('user_type')
   console.log('side menu type', user_type)
   const {
        stats,      
        isLoading,
        error,
      } = useUserDashboardStatsQuery({
        page:1,
      });
      

   if(user_type === 'user'){
      //users/doctor menu
      const menu = [{
            label:'Dashboard',
            link:Links.MYDASHBOARD,
         },
         {
            label:`My Forums(${stats?.total_forum_posts ?? 0})`,
            link:Links.MYFORUMS,
         },
         {
            label:`My Screens(${stats?.total_screens_created ?? 0})`,
            link:Links.MYSCREENS,
         },
         {
            label:`My Followed Screens(${stats?.total_screens_followed ?? 0})`,
            link:Links.MYFOLLOWEDSCREENS,
         },
         {
            label:'Profile',
            link:Links.PROFILE,
         },
        
      ]
      return menu
   }
   if(user_type === 'expert'){
      const menu = [
          {
            label:"My Dashboard",
            link:Links.DOCTORDASHBOARD,
         },
         {
            label:'Profile',
            link:Links.PROFILE_DOCTOR,
         },
        
        
        
      ]
      return menu
   }   

   return []
}